import axios from 'axios';

const getFromBannerApi = async (host, config = null) => {
  const url = host || 'https://apionline.homedepot.com';
  let bannerHost = url + '/sponsoredbanner/v1';
  return axios.get(bannerHost, config);
};

export { getFromBannerApi };
